import { render, staticRenderFns } from "./LogoDescription.vue?vue&type=template&id=53f7e1d5&scoped=true"
import script from "./LogoDescription.vue?vue&type=script&lang=js"
export * from "./LogoDescription.vue?vue&type=script&lang=js"
import style0 from "./LogoDescription.vue?vue&type=style&index=0&id=53f7e1d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f7e1d5",
  null
  
)

export default component.exports